/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_TitleInputs */

const en_guide_what_is_json_title = /** @type {(inputs: Guide_What_Is_Json_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is JSON? A Complete Beginner's Guide: PureJSON`)
};

const ko_guide_what_is_json_title = /** @type {(inputs: Guide_What_Is_Json_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON이란? 초보자를 위한 완벽 가이드: PureJSON`)
};

const ja_guide_what_is_json_title = /** @type {(inputs: Guide_What_Is_Json_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONとは？初心者向け完全ガイド: PureJSON`)
};

/**
* | output |
* | --- |
* | "What is JSON? A Complete Beginner's Guide: PureJSON" |
*
* @param {Guide_What_Is_Json_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_title = /** @type {((inputs?: Guide_What_Is_Json_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_title(inputs)
	if (locale === "ko") return ko_guide_what_is_json_title(inputs)
	return ja_guide_what_is_json_title(inputs)
});